import { ElementWithProps, createComponent } from '@carvana/merch-components';
import { DESKTOP_ELLIPSE_MASK } from './OrderStatusModule.masks';

export const DesktopEllipse = createComponent<ElementWithProps>('div', {
  className:
    'absolute bg-no-repeat [background-position:42%_28%] [background-size:auto_50%] h-[960px] top-[-201px] w-[960px] [mask-image:var(--desktop-ellipse-mask)] [mask-repeat:no-repeat] [mask-size:100%_100%]',
  style: {
    '--desktop-ellipse-mask': DESKTOP_ELLIPSE_MASK
  } as React.CSSProperties
});
